import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const stagger = { visible: { transition: { staggerChildren: 0.09 } } };

export default function Services({ t }) {
  const services = t.services.items;

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-32 bg-[#0F0F0F]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <motion.p
            variants={fadeUp}
            className="text-xs tracking-[0.3em] sm:tracking-[0.38em] uppercase text-[#D4AF37] font-body mb-4"
          >
            {t.services.sectionTitle}
          </motion.p>
          <motion.h2
            variants={fadeUp}
            className="text-4xl md:text-5xl font-bold text-white font-heading"
            data-testid="services-title"
          >
            {t.services.headline}
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          data-testid="services-list"
        >
          {services.map((service, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              className="flex items-start justify-between py-7 border-b border-white/6 group hover:border-[#D4AF37]/25 transition-colors duration-300 cursor-default"
              data-testid={`service-item-${i}`}
            >
              <div className="flex-1 min-w-0 pr-4 sm:pr-8">
                <h3 className="text-xl font-heading text-white group-hover:text-[#D4AF37] transition-colors duration-300 mb-1">
                  {service.name}
                </h3>
                <p className="text-white/65 text-sm font-body leading-relaxed">{service.description}</p>
              </div>
              <div className="shrink-0 pt-1">
                <span className="text-[#D4AF37] font-heading text-lg sm:text-xl font-bold whitespace-nowrap text-right">
                  {service.price}
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="text-center mt-14"
        >
          <a
            href="tel:+994555525001"
            className="inline-flex items-center px-10 sm:px-14 py-4 border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-colors duration-300 text-xs tracking-[0.28em] uppercase font-body font-bold"
            data-testid="services-cta"
          >
            {t.services.bookNow}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
